import React from 'react';

/**
 * Delt komponent for å vise offisielle Merkeskyting-ikoner (Nybegynner,
 * Viderekommende, Bronse, Sølv, Gull) som PNG. Bildene ligger i
 * `/badges/` i public og kan brukes overalt i appen.
 */
const BADGE_SRC = {
  nybegynner: '/badges/nybegynner.png',
  viderekommende: '/badges/viderekommende.png',
  bronse: '/badges/bronse.png',
  solv: '/badges/solv.png',
  gull: '/badges/gull.png',
};

const BADGE_LABELS = {
  nybegynner: 'Nybegynner',
  viderekommende: 'Viderekommende',
  bronse: 'Bronse',
  solv: 'Sølv',
  gull: 'Gull',
};

const BadgeIcon = ({ level, size = 40, className = '', style = {}, title }) => {
  const src = BADGE_SRC[level];
  const label = title || BADGE_LABELS[level] || level;
  if (!src) return null;
  return (
    <img
      src={src}
      alt={label}
      title={label}
      className={className}
      style={{ width: size, height: size, objectFit: 'contain', ...style }}
      data-testid={`badge-icon-${level}`}
    />
  );
};

export { BadgeIcon, BADGE_LABELS, BADGE_SRC };
export default BadgeIcon;
